import React from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';

import ColorWrapper, { WithColor } from '@styles/colors';
import { scale } from '@components/frame';
import { isPhone } from '@helpers';
import { font } from '@styles/fonts';
import Svg from '@styles/icons/svg';
import Button from '@styles/buttons';

import { TEST_IDS } from '@v2/pages/common/constants/base.constants';
import { CONTENT_WIDTH_TABLET, LOGO_HEIGHT, LOGO_WIDTH } from './constants';

export interface TenantStatusLayoutProps extends WithColor {
  title: string;
  body: string;
  primaryAction?: React.ReactNode;
  onLogOut: () => void;
  testID?: string;
  logOutTestID?: string;
}

const TenantStatusLayout = ({ C, title, body, primaryAction, onLogOut, testID, logOutTestID }: TenantStatusLayoutProps) => {
  return (
    <View
      testID={testID ?? TEST_IDS.tenantStatus.layout.container}
      style={{
        flex: 1,
        width: '100%',
        backgroundColor: C('Background/Light/Detail'),
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: scale(20),
      }}
    >
      <View style={{ width: isPhone ? '100%' : scale(CONTENT_WIDTH_TABLET), alignItems: 'center' }}>
        <Svg icon="smartFactory" width={scale(LOGO_WIDTH)} height={scale(LOGO_HEIGHT)} color="Other/Light/Logo/Factory" />
        <Text style={[font['Title 1'], { color: C('Label/Light/Primary'), textAlign: 'center', marginTop: scale(20) }]}>{title}</Text>
        <Text style={[font['Body'], { color: C('Label/Light/Secondary'), textAlign: 'center', marginTop: scale(12) }]}>{body}</Text>
        {primaryAction ? <View style={{ marginTop: scale(40), width: '100%' }}>{primaryAction}</View> : null}
        <View style={{ marginTop: scale(primaryAction ? 16 : 40), width: '100%' }}>
          <Button
            variant="Dialog M"
            type="Tertiary"
            onPress={onLogOut}
            testID={logOutTestID ?? TEST_IDS.tenantStatus.layout.logOutButton}
          >
            {i18n.t('Log out')}
          </Button>
        </View>
      </View>
    </View>
  );
};

export default ColorWrapper(TenantStatusLayout);
